import type { ICoupon } from "@src/types/AppTypes";
import { createContext } from "react";

export const CouponContext = createContext<{
  coupon: ICoupon;
  setCoupon: React.Dispatch<{ payload: ICoupon; type: "updateCoupon" }>;
}>({
  coupon: { couponCode: "", isApplied: false, discount: "" },
  setCoupon: () => {},
});

export function couponReducer(
  state: ICoupon,
  action: { payload: ICoupon; type: "updateCoupon" }
) {
  if (action.type === "updateCoupon") {
    return action.payload;
  } else {
    return state;
  }
}
